module.exports = __webpack_public_path__ + "img/3.0de46e39.png";